import { render, staticRenderFns } from "./FormEditarGrupo.vue?vue&type=template&id=4a26eb1a"
import script from "./FormEditarGrupo.vue?vue&type=script&lang=js"
export * from "./FormEditarGrupo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports